import { get, post } from './api';

export const getCompaniesSettingsApi = async () => {
  return await get(`CompaniesSettings/GetSettings`);
};

export const updateSettingsCompanyApprovals = async (data) => {
  return await post(`CompaniesSettings/UpdateSettings/CompanyApprovals`, data);
};
